import React, {useState, useEffect} from 'react'
import PropTypes from 'prop-types';
import { LocalizeContextProps, Translate, withLocalize } from 'react-localize-redux';
import { Search as SearchPatientIcon } from "@mui/icons-material";
import { Box, Grid, Paper, Typography, Button} from '@mui/material';
import Form  from '../../components/general/form';
import {useHistory, useParams} from 'react-router-dom';
import Loader from '../../components/Loader';
import PatientsTable from '../../components/general/PatientsTable';
import { ButtonBack, ButtonCancel, ButtonContinue, GridContainer } from '../../components/general/mini_components';
import { connect } from 'react-redux';
import { useDispatch } from "react-redux";
import { updatePatientsFromId } from '../../redux/actions/patientsActions';
import _ from 'lodash';
import Modal from '../../components/general/modal';
import { DepartmentsAccordionRedux } from './departments/DepartmentsAccordion';
import { decryptSinglePatientData, getPatientID, yearsFromDate } from '../../utils/index.jsx';
import ICT from '../../components/general/SmartFields/ICT';
import { searchPatientByDiagnosis } from '../../services';
import PatientAppointmentInfo from './Outpatients/PatientAppointmentInfo';
import { HOSPITAL_BILLING_PATIENT, HOSPITAL_PATIENT } from '../../routes/urls';
import { TabsSherwood } from '../components/Tabs';
import RequestForm from './Request/RequestForm';
import { ServiceType } from './Request/types';
import { IPatient } from '../../constants/types';
import PatientInfo from '../../components/PatientInfo';
import { fetchPatient } from '../../db';

let personalFieldsForm = {};
const ID_FIELD = {
    name : "id",
    required: false,
    type : "text",
    label : "id",
    order: 0
}

function SearchPatients(props: any){
    const [valuesSearch, setValuesSearch] = useState(null);
    const [showResults, setShowResults] = useState(false);
    const [filteredPatients, setFilteredPatients] = useState<IPatient[]>([]);
    const [patientsDiagnoseLoading, setPatientsDiagnoseLoading] = useState(false);
    const insurances = props.investigations.currentInvestigation ? props.investigations.currentInvestigation.insurances : [];
    const outpatientsInfo = props.investigations.currentInvestigation ? props.investigations.currentInvestigation.outpatientsInfo : {};
    const patients = props.patients.data && props.investigations.currentInvestigation ? props.patients.data[props.investigations.currentInvestigation.uuid] : [];
    const [actionPatient, setActionPatient] = useState<PatientAction | null>(null);
    const dispatch = useDispatch();
    const history = useHistory();
    const { action, uuidPatient } = useParams();
    const [selectedPatient, setSelectedPatient] = useState<IPatient | null>(null);

    async function searchPatientCallBack(values: any) {
        console.log(values);
        setValuesSearch(values);
        
        const maxPatId = patients.length === 0 ? 0 : patients.length === 1 ? patients[0].id : Math.max.apply(Math, patients.map(function(o) { return o.id; }));

        await dispatch(updatePatientsFromId(props.investigations.currentInvestigation, maxPatId)); 
        
    }
    function diagnoseSelectedCallBack(ict: any) {
        setPatientsDiagnoseLoading(true);
        searchPatientByDiagnosis(props.investigations.currentInvestigation.uuid, ict["ict-code"])
        .then(response => {
            setShowResults(true); 
            const decryptedPatients = response.patients.map(patient => {
                patient.personalData = decryptSinglePatientData(patient.personalData, props.investigations.currentInvestigation);
                return patient;
            })
            setFilteredPatients(decryptedPatients);
            setPatientsDiagnoseLoading(false);
        })
        .catch(error =>{
            console.error(error);
            setPatientsDiagnoseLoading(false);
        })
    }
    function backToSearchCallBack() {
        setFilteredPatients([]);
        setShowResults(false);
    }
    
    async function patientSelectedCallBack(uuid: string) {
        const nextUrl = HOSPITAL_PATIENT.replace(":uuidPatient", uuid)
        history.push(nextUrl);
    }

    async function billingPatientCallBack(uuid: string) {
        const nextUrl = HOSPITAL_BILLING_PATIENT.replace(":uuidPatient", uuid)
        history.push(nextUrl);
    }

    
    useEffect(() => {
        if(!props.patients.loading && valuesSearch !== null){
            setShowResults(true); 
            let filteredPatients: IPatient[] = [];
            if((valuesSearch as any).hasOwnProperty("id")){
                filteredPatients = patients.filter((pat: IPatient) => pat.id === parseInt((valuesSearch as any)["id"]))
            }
            else{
                //Filtrar decryptedPatientData con values
                filteredPatients = patients.sort((a: IPatient, b: IPatient) => b.id - a.id).filter((patient: IPatient) =>{
                    let result = true;
                    for(const keyValue of Object.keys(valuesSearch)){
                        const value = (valuesSearch as any)[keyValue];
                        const pF = props.investigations.currentInvestigation.personalFields.find((pp: any) => pp.name === keyValue);
                        if(pF.options.length > 0){
                            if(value !== "" && (patient.personalData as any)[keyValue] !== value){
                                result = false;
                            }
                        }
                        else{
                            console.log("keyValue", keyValue);
                            console.log("Birthdate", (patient.personalData as any)[keyValue]);
                            if(keyValue === "birthdate"){
                                const birthdayFind = new Date(value);
                                const patientBirthday = (patient.personalData as any)["birthdate"];
                                result = patientBirthday.getFullYear() === birthdayFind.getFullYear() &&
                                            patientBirthday.getMonth() === birthdayFind.getMonth() &&
                                            patientBirthday.getDate() === birthdayFind.getDate()
                                console.log("Result", result);
                            }
                            else if(keyValue === "automated_health_id" && value !== ""){
                                result = (patient.personalData as any)["automated_health_id"] === value;
                            }
                            else if(value !== "" && (patient.personalData as any)[keyValue] && !(patient.personalData as any)[keyValue].toLowerCase().includes(value.toLowerCase())){
                                result = false;
                            }
                        }
                    }
                    return result;
                });
            }
            setFilteredPatients(filteredPatients);
        }
    }, [props.patients.loading])

    // Handle URL parameters
    useEffect(() => {
        if (uuidPatient && patients.length > 0) {
            const patient = patients.find(p => p.uuid === uuidPatient);
            if (patient) {
                setFilteredPatients([patient]);
                setShowResults(true);
                
                if (action) {
                    setActionPatient({action: action, patient: patient});
                }
            }
        }
    }, [uuidPatient, patients, action]);

    if(!props.investigations.data || !props.investigations.currentInvestigation || props.patients.loading || patientsDiagnoseLoading){
        return <Loader />
    }
    return(
        <React.Fragment>
            <SearchPatientsComponent showResults={showResults} 
                patients={filteredPatients} investigation={props.investigations.currentInvestigation}
                personalFields={props.investigations.currentInvestigation.personalFields}
                permissions={props.investigations.currentInvestigation.permissions}
                functionalities={props.investigations.currentInvestigation.functionalities}
                insurances={insurances} outpatientsInfo={outpatientsInfo}
                initActionPatient={actionPatient}
                searchPatientCallBack={searchPatientCallBack}
                backToSearchCallBack={backToSearchCallBack} 
                patientSelectedCallBack={patientSelectedCallBack}
                billingPatientCallBack={billingPatientCallBack}
                diagnoseSelectedCallBack={diagnoseSelectedCallBack}
                    />
        </React.Fragment>                          
    )
}

const mapStateToProps = (state) =>{
    return {
        patients : state.patients,
        investigations:state.investigations
    }
}

SearchPatients.propTypes = {
    personalFields:PropTypes.array,
}

export default connect(mapStateToProps, null)(SearchPatients)

type PatientAction = {
    action: 'appointment' | 'pre-hospitalize' | 'hospitalize' | 'surgery' | string; // string for future actions
    patient: IPatient;
  }

interface SearchPatientsProps extends LocalizeContextProps {
    showResults: boolean;
    patients: IPatient[];
    investigation: any;
    personalFields: any[];
    permissions: any[];
    functionalities: any[];
    insurances: any[];
    outpatientsInfo: any;
    initActionPatient: PatientAction | null;
    searchPatientCallBack: (values: any) => void;
    backToSearchCallBack: () => void;
    patientSelectedCallBack: (uuid: string) => void;  
    diagnoseSelectedCallBack: (ict: any) => void;
    billingPatientCallBack: (uuid: string) => void;
}


export const SearchPatientsComponent = withLocalize((props: SearchPatientsProps) => {
    const [actionPatient, setActionPatient] = useState<PatientAction | null>(props.initActionPatient);


    useEffect(() => {
        setActionPatient(props.initActionPatient);
    }, [props.initActionPatient]);

    function backToSearch(){
        props.backToSearchCallBack()
    }

    async function hospitalizePatient(uuid: string) {
        const fetchedPatient = await fetchPatient(uuid);
        if (fetchedPatient) {
            setActionPatient({patient: fetchedPatient, action : "pre-hospitalize"});
        }
    }
    async function billingPatient(uuid: string) {
        const fetchedPatient = await fetchPatient(uuid);
        if (fetchedPatient) {
            props.billingPatientCallBack(fetchedPatient.uuid);
        }
    }

    async function selectAppointmentPatient(uuid: string) {
        const fetchedPatient = await fetchPatient(uuid);
        if (fetchedPatient) {
            setActionPatient({action: "appointment", patient: fetchedPatient});
        }
    }

    async function surgeryPatient(uuid: string) {
        const fetchedPatient = await fetchPatient(uuid);
        if (fetchedPatient) {
            setActionPatient({action: "surgery", patient: fetchedPatient});
        }
    }
    
    function confirm(){
        setActionPatient({...actionPatient, action: "hospitalize"});
    }
    function resetModal(){
        setActionPatient(null);
    }

    function renderModal(){
        if(actionPatient?.patient){
            return (
                <Modal key="modal" open={Boolean(actionPatient.patient)} 
                    title={<Translate id={`hospital.search_patient.modal.${actionPatient.action}.title`}/>} 
                    closeModal={resetModal} >
                            <>
                            {
                            (actionPatient && actionPatient.action === 'pre-hospitalize')&&
                            <Grid container>
                                <Grid item xs={12}>
                                    <Typography variant="body1">
                                        <Translate id="hospital.search_patient.modal.pre-hospitalize.body" />

                                    </Typography>
                                    <PatientInfo uuidPatient={actionPatient.patient.uuid} />
                                </Grid>
                                <Grid item xs={12} style={{paddingTop:'1rem'}}>
                                    <ButtonCancel onClick={resetModal} data-testid="cancel-modal" color="primary" spaceright={1}>
                                        <Translate id="general.cancel" />
                                    </ButtonCancel>
                                    &nbsp;
                                    <ButtonContinue onClick={confirm} data-testid="continue-modal" color="green">
                                        <Translate id="general.continue" />
                                    </ButtonContinue>
                                </Grid>
                                
                            </Grid>
                        }
                        {
                            actionPatient && actionPatient.action === "hospitalize" &&
                            <DepartmentsAccordionRedux currentInvestigation={props.investigation} 
                                
                                uuidPatient={actionPatient.patient.uuid} />
                        }
                        {
                            actionPatient && actionPatient.action === "appointment" &&
                            <PatientAppointmentInfo uuidInvestigation={props.investigation.uuid}  uuidPatient={actionPatient.patient.uuid} 
                                outpatientsInfo={props.outpatientsInfo} phoneNumber={ Array(props.outpatientsInfo.sms) ? actionPatient.patient.personalData.phone : ""}
                                resetModal={resetModal}
                                appointmentMadeCallback={resetModal} /> 
                        }
                        {
                            actionPatient && actionPatient.action === "surgery" &&
                            <RequestForm uuidInvestigation={props.investigation.uuid}  uuidPatient={actionPatient.patient.uuid} 
                                serviceType={ServiceType.SURGERY} cancel={resetModal}
                                units={[]}
                                callBackRequestFinished={resetModal}/> 
                        }
                        </>
                </Modal>
            )   
        }
        else{
            return null;
        }
        
    }

    function renderCore(){
        if(!props.showResults){
            let personalFieldsForm = {}
            props.personalFields.sort((a,b) => a.order - b.order).forEach(personalField => {
                            const copyField = {...personalField};
                            copyField.required = false;
                            personalFieldsForm[personalField.name] = copyField
                        });
            if(Object.keys(personalFieldsForm).length === 0){
                personalFieldsForm["id"] = ID_FIELD;
            }      
            
            return (
                <TabsSherwood initTab={0} name="Search Patients" 
                    labels={[<Translate id="pages.hospital.search-patient.by-personal-details" />, <Translate id="pages.hospital.search-patient.by-diagnose" />]} >
                    <Box label={<Translate id="pages.hospital.search-patient.by-personal-details" />}>
                        <Paper style={{padding:'1rem', margin:'1rem'}}>
                            <Translate id="pages.hospital.search-patient.note" />
                            <Form fields={personalFieldsForm} 
                                submitText="investigation.search-patients.search" callBackForm={props.searchPatientCallBack} />                        
                        </Paper>
                    </Box>
                    <Box label={<Translate id="pages.hospital.search-patient.by-diagnose" />}>
                        <Paper style={{padding:'1rem', margin:'1rem'}}>
                            <ICT language={props.activeLanguage.code} elementSelected={props.diagnoseSelectedCallBack}/>
                        </Paper>
                    </Box>
                </TabsSherwood> 
            );
        }
        else{
            if(props.patients.length === 0){
                return ([
                    <Box mb={2}>
                        <Paper style={{padding:'1rem'}}>
                            No patients meet the criteria
                        </Paper>
                    </Box>,    
                    <ButtonBack mt={2} onClick={backToSearch}><Translate id="pages.hospital.search-patient.back-button" /></ButtonBack>,
                ])
            }
            else{
                let formSearch = [...props.personalFields]
                if(formSearch.length === 0){
                    formSearch.push(ID_FIELD);
                } 
                console.log("Patients Results", props.patients);
                return(
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <PatientsTable patients={props.patients} 
                                personalFields={formSearch} permissions={props.permissions}
                                functionalities={props.functionalities}
                                insurances={props.insurances ? props.insurances : []}
                                showPatientCallBack={id => props.patientSelectedCallBack(id)} 
                                selectAppointmentPatientCallBack={(index) => selectAppointmentPatient(index)}
                                billingPatientCallBack={(index) => billingPatient(index)}
                                hospitalizePatientCallBack={(index) => hospitalizePatient(index)} 
                                surgeryPatientCallBack={(index) => surgeryPatient(index)}
                                />
                        </Grid>
                        <Grid item xs={12}>
                            <ButtonBack onClick={backToSearch}><Translate id="pages.hospital.search-patient.back-button" /></ButtonBack>
                        </Grid>
                    </Grid>)
            }
        }
    }
   
    
    return (
        <React.Fragment>
            {
                renderModal()
            }
            <Grid container spacing={2} >
                <GridContainer item xs={12}>
                    <SearchPatientIcon style={{fontSize:"2.5rem"}} />
                    <Typography variant="h1" gutterBottom display="inline" style={{marginBottom:"0px"}}>
                        <Translate id="pages.hospital.search-patient.title" />
                    </Typography>
                </GridContainer>
                
                <Grid item xs={12}>
                    {
                        renderCore()
                    }     
                </Grid>         
            </Grid>
        </React.Fragment>
    )
})